const passwordVisibility = (buttonId = 'passwordToggle') => {
    const $button = $('#' + buttonId);

    if (!$button) {
        return;
    }

    $button.on('click', function () {
        if ($button.hasClass('fa-eye')) {
            $button.removeClass('fa-eye').addClass('fa-eye-slash');
            $button.prev().prop('type', 'text');
        } else {
            $button.removeClass('fa-eye-slash').addClass('fa-eye');
            $button.prev().prop('type', 'password');
        }
    });
};

export default passwordVisibility;
